export type InboxSelectable = {
  conversationId: number;
};

/**
 * Escolhe qual conversa o inbox abre quando a lista termina de carregar.
 * Uma seleção já feita permanece. Um id pendente (deep link) só é escolhido
 * se estiver na página; caso contrário a primeira linha não entra no lugar.
 * Sem id pendente, a primeira linha continua sendo a abertura normal do inbox.
 */
export function resolveInboxAutoSelection<T extends InboxSelectable>(
  chats: readonly T[],
  pendingConversationId: number | null | undefined,
  current: T | null
): T | null {
  if (current) return current;

  const pending = Number(pendingConversationId);
  if (Number.isFinite(pending) && pending > 0) {
    return chats.find((chat) => chat.conversationId === pending) ?? null;
  }

  return chats[0] ?? null;
}
